import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  LabelStyled,
  SpanStyled,
  TextStyled,
} from "../../styled/Elements";
import { Form, FormGroup } from "react-bootstrap";
import styled from "styled-components";
import { Eye, Eyelash } from "../../styled/AllImages";
import { useTranslation } from "react-i18next";
import ValidationErrorText from "./ValidationErrorText";

const ValidatedInput = ({
  name,
  type,
  fieldType,
  placeholder,
  label,
  value,
  register,
  validationRules,
  className,
  disabled,
  staric,
  errors,
  classNameLabel,
  innerTxt,
  errorMessage = "",
  innerIcon,
  onChange,
  min,
  ...rest
}) => {
  const { t } = useTranslation();
  const [showType, setType] = useState(fieldType);

  const inputStyles = type === "textarea" ? { height: "130px" } : {};
  const inputRef = useRef(null);

  useEffect(() => {
    if (fieldType === "number" && inputRef.current) {
      const input = inputRef.current;
      const preventScroll = (e) => e.preventDefault();
      input.addEventListener("wheel", preventScroll, { passive: false });
      return () => input.removeEventListener("wheel", preventScroll);
    }
  }, [fieldType]);

  return (
    <ValidatedInputWrapper className={className} {...rest}>
      <FormGroup controlId={name} className="formEleContainer">
        {label && (
          <LabelStyled className={classNameLabel}>
            {t(label)}
            {staric && <span className="staric">*</span>}
          </LabelStyled>
        )}
        <Box
          className={`position-relative w-100 ${
            innerTxt ? "innerInpWrap" : ""
          }`}
        >
          <Form.Control
            ref={inputRef}
            onChange={onChange}
            name={name}
            as={type}
            type={showType}
            value={value}
            disabled={disabled}
            className="validated-input"
            placeholder={t(placeholder)}
            style={inputStyles}
            onKeyDown={(e) => {
              if (fieldType === "number" && (e.key === "-" || e.key === "e")) {
                e.preventDefault();
              }
            }}
            onWheel={(e) => {
              if (fieldType === "number") {
                e.target.blur();
              }
            }}
            {...(fieldType === "number" && {
              min: 0,
              step: "any",
            })}
            {...(register && register(name, validationRules))}
          />
          {fieldType === "password" && (
            <>
              {showType === "password" ? (
                <Eyelash
                  className="eye-btn position-absolute cursor-pointer"
                  onClick={() => setType("text")}
                />
              ) : (
                <Eye
                  className="eye-btn position-absolute cursor-pointer"
                  onClick={() => setType("password")}
                />
              )}
            </>
          )}
          {innerTxt && (
            <TextStyled className="innerInpLabel">{innerTxt}</TextStyled>
          )}
          {errors && (
            <>
              {errors[name]?.type === "required" && (
                <ValidationErrorText
                  text={
                    t(errors[name]?.message) ||
                    `${t(label || name)} ${t("isRequired")}.`
                  }
                  //   extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "minLength" && (
                <ValidationErrorText
                  text={t(errors[name]?.message)}
                  //   extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "maxLength" && (
                <ValidationErrorText
                  text={t(errors[name]?.message)}
                  //   extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "pattern" && (
                <ValidationErrorText
                  text={t(errors[name]?.message || errorMessage)}
                  //   extraClass={errorDisplay}
                />
              )}
              {errors[name]?.type === "validate" && (
                <ValidationErrorText
                  text={t(errors[name]?.message || errorMessage)}
                  //   extraClass={errorDisplay}
                />
              )}
            </>
          )}
        </Box>
      </FormGroup>
    </ValidatedInputWrapper>
  );
};

export default ValidatedInput;

export const ValidatedInputWrapper = styled.div`
  width: 100%;
  padding: 0px 0px 0px 0px;
  border-bottom: 1px solid var(--borderLight);
  width: 100%;
  .formEleContainer {
    display: flex;
    padding: 0px 0px 0px 0px;
    margin: 10px 0 10px 0;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
    & > label {
      min-width: 160px;
      body.rtl & {
        //font-family: var(--arRegular);
      }

      &.w-auto {
        min-width: auto;
      }
    }
    &.inp-white {
      input {
        background-color: var(--white);
      }
    }
  }

  &.flex-wrap {
    .formEleContainer {
      flex-wrap: wrap;
      label {
        width: 100%;
      }
    }
  }
  .form-floating {
    width: 100%;
  }
  input[type="text"] {
    width: 100%;
  }

  .form-control {
    height: 48px;
    box-shadow: none;
    outline: none;
    border-radius: 10px;
    border: 1px solid var(--border);
    background-color: ${({ bg }) => (bg ? bg : "var(--bg)")};
    font-family: var(--regular);
    &::placeholder {
      color: var(--lightGrey);
    }
    body.rtl & {
      font-family: var(--arRegular);
    }
  }
  .form-control:focus {
    box-shadow: none;
    outline: none;
    border: 1px solid var(--border);
  }
  .innerInpWrap {
    input {
      padding-right: 100px;
      body.rtl & {
        padding-right: 0.75rem;
        padding-left: 100px;
      }
    }
  }
  .innerInpLabel {
    position: absolute;
    right: 24px;
    line-height: 48px;
    padding-left: 24px;
    width: fit-content;
    top: 1px;
    &::before {
      content: "";
      width: 1px;
      height: 20px;
      background-color: var(--lightGrey2);
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      left: 0;
    }
    body.rtl & {
      right: auto;
      left: 24px;
      padding-left: 0;
      padding-right: 24px;
      &::before {
        left: auto;
        right: 0;
      }
    }
  }
  @media (max-width: 767px) {
    .formEleContainer {
      flex-wrap: wrap;
      gap: 3px;
      margin: 0;
      padding: 6px 0px 6px 0px;
      label {
        width: 100%;
      }
    }
  }
`;
